import _extends from 'babel-runtime/helpers/extends';

import { crmQueryImportNumAPI, crmQueryImportInfoAPI, crmDownImportErrorAPI, filedGetFieldAPI } from '@/api/crm/common';
import { crmCustomerExcelImportAPI, crmCustomerDownloadExcelAPI, crmCustomerPoolDownloadExcelAPI, crmCustomerPoolNameListAPI, crmCustomerPoolExcelImportAPI } from '@/api/crm/customer';
import { crmLeadsExcelImportAPI, crmLeadsDownloadExcelAPI } from '@/api/crm/leads';
import { crmContactsExcelImportAPI, crmContactsDownloadExcelAPI } from '@/api/crm/contacts';
import { crmProductExcelImportAPI, crmProductDownloadExcelAPI } from '@/api/crm/product';

import { XhUserCell } from '@/components/CreateCom';
import ImportHistory from './ImportHistory';
import XrImport from './XrImport';

// import { mapGetters } from 'vuex'
import crmTypeModel from '@/views/crm/model/crmTypeModel';
import { downloadExcelWithResData, verifyFileTypeWithFileName } from '@/utils';
import Lockr from 'lockr';
import merge from '@/utils/merge';
import ImportMixins from './ImportMixins';

var DefaultProps = {
  typeName: '', // 模块名称
  ownerSelectShow: false,
  poolSelectShow: false, // 代表是公海 导入模板也不一样
  historyShow: true,
  repeatHandleShow: true,
  repeatRuleShow: true, // 步骤二的重复规则是否展示
  importRequest: null, // 导入请求
  importParams: null, // 导入参数
  templateRequest: null, // 模板请求
  templateParams: null, // 导入模板参数
  noImportProcess: false, // 无导入过程，上传完附件直接出结果
  downloadErrFuc: null, // 自定义下载错误的方法
  userInfo: null // 当前登录人信息
};

export default {
  name: 'WkCRMImport', // 文件导入
  components: {
    XhUserCell: XhUserCell,
    ImportHistory: ImportHistory,
    XrImport: XrImport
  },
  mixins: [ImportMixins],
  props: {
    // show: {
    //   type: Boolean,
    //   default: false
    // }
    // // CRM类型
    // crmType: {
    //   type: String,
    //   default: ''
    // },
    // props: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   }
    // },
    // 是有缓存的信息展示的页面 是否完成状态
    // cacheShow: {
    //   type: Boolean,
    //   default: false
    // },
    // cacheDone: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data: function data() {
    return {
      loading: false,
      fieldList: [],
      repeatHandling: 1, // 	1 覆盖，2跳过
      file: { name: '' },
      user: [],

      // 公海数据
      poolId: '',
      poolList: [],

      stepsActive: 1,
      stepList: [{
        icon: 'wk wk-upload',
        title: '上传文件',
        status: 'wait'
      }, {
        icon: 'wk wk-data-import',
        title: '导入数据',
        status: 'wait'
      }, {
        icon: 'wk wk-success',
        title: '导入完成',
        status: 'wait'
      }],
      resultData: null,
      processData: {
        count: 0,
        status: ''
      },
      messageId: null,
      intervalTimer: null,

      historyPopoverShow: false
    };
  },

  computed: {
    // ...mapGetters(['userInfo']),
    crmTypeName: function crmTypeName() {
      if (this.crmProps && this.crmProps.typeName) {
        return this.crmProps.typeName;
      }

      return {
        customer: '客户',
        leads: '线索',
        contacts: '联系人',
        product: '产品'
      }[this.crmType] || '';
    },
    importLoadingText: function importLoadingText() {
      if (this.processData.count) {
        return '\u6570\u636E\u5BFC\u5165\u4E2D\uFF08\u5F53\u524D\u5DF2\u5BFC\u5165' + this.processData.count + '\u6761\uFF09';
      }

      return '数据导入中';
    },
    sureTitle: function sureTitle() {
      return {
        1: '立即导入',
        2: '最小化',
        3: '确定'
      }[this.stepsActive];
    },
    showCancel: function showCancel() {
      return this.stepsActive != 2;
    },
    fieldUniqueInfo: function fieldUniqueInfo() {
      var uniqueList = this.fieldList.filter(function (item) {
        return item.isUnique == 1;
      });

      return uniqueList.map(function (item) {
        return item.name;
      }).join('/') || '无';
    },
    config: function config() {
      return merge(_extends({}, DefaultProps), this.crmProps || {});
    }
  },
  watch: {
    cacheShow: {
      handler: function handler(val) {
        // 展示缓存
        if (val) {
          // this.$emit('update:cacheShow', false)
          this.cacheShow = false;
          var beforeImportInfo = Lockr.get('crmImportInfo');
          if (beforeImportInfo && beforeImportInfo.messageId) {
            this.loading = true;
            this.messageId = beforeImportInfo.messageId;
            this.stepList[0].status = 'finish';

            if (this.cacheDone) {
              this.stepList[1].status = 'finish';
              this.stepsActive = 3;
              this.thirdQueryResult();
            } else {
              this.stepsActive = 2;
              this.stepList[1].status = 'process';
            }

            this.loopSecondQueryNum();
          }
        }
      },

      immediate: true
    },

    showCRMImport: {
      handler: function handler(val) {
        if (val) {
          // 阶段一展示 需要获取的信息
          if (this.stepsActive == 1) {
            if (this.config.userInfo) {
              this.user = [this.config.userInfo];
            }

            if (this.config.poolSelectShow) {
              this.getPoolList();
            }

            if (this.config.repeatRuleShow && this.config.repeatHandleShow) {
              this.getField();
            }
          }
        } else {
          if (this.stepsActive == 3) {
            this.resetData();
          }

          this.fieldList = [];
        }
      },

      immediate: true
    },

    stepsActive: function stepsActive() {
      // this.$emit('status', {
      //   1: 'wait',
      //   2: 'process',
      //   3: 'finish'
      // }[this.stepsActive])

      this.crmImportChange({
        1: 'wait',
        2: 'process',
        3: 'finish'
      }[this.stepsActive]);
    }

    // file() {
    //   this.getFirstStepStatus()
    // },

    // user() {
    //   this.getFirstStepStatus()
    // }

  },
  created: function created() {},

  methods: {
    import: function _import(crmType, props) {
      if (this.crmType != crmType && this.showFixImport) {
        this.$message.error('请先处理当前导入的数据');
      } else {
        this.crmType = crmType;
        this.crmProps = props;
        this.showCRMImport = true;
      }
    },
    sureClick: function sureClick() {
      var _this = this;

      if (this.stepsActive == 1) {
        if (this.stepList[0].status == 'finish') {
          this.stepList[1].status = 'process';
          this.stepsActive = 2;
          this.firstUpdateFile(function (res) {
            var resData = res.data || {};
            if (_this.config.noImportProcess) {
              _this.loading = false;
              _this.stepList[1].status = 'finish';
              _this.stepsActive = 3;
              _this.$emit('status', 'finish');
              _this.resultData = resData;
              if (resData.errSize > 0) {
                _this.stepList[2].status = 'error';
              } else {
                _this.stepList[2].status = 'finish';
              }
            } else {
              _this.messageId = resData;

              // 写入本次缓存
              Lockr.set('crmImportInfo', {
                messageId: _this.messageId,
                crmProps: _this.config,
                crmType: _this.crmType
              });

              _this.loopSecondQueryNum();
            }
          });
        } else {
          if (!this.file.name) {
            this.$message.error('请选择导入文件');
          } else if (this.config.ownerSelectShow && (!this.user || this.user.length == 0)) {
            this.$message.error('请选择负责人');
          }
        }
      } else {
        this.closeView();
      }
    },


    /**
     * 第一步上传
     */
    firstUpdateFile: function firstUpdateFile(result) {
      var _this2 = this;

      var params = {};
      params.repeatHandling = this.repeatHandling;
      params.file = this.file;
      if (this.config.ownerSelectShow) {
        params.ownerUserId = this.user.length > 0 ? this.user[0].userId : '';
      }
      if (this.config.poolSelectShow) {
        params.poolId = this.poolId;
      }

      var request = this.config.importRequest || {
        customer: this.config.poolSelectShow ? crmCustomerPoolExcelImportAPI : crmCustomerExcelImportAPI,
        leads: crmLeadsExcelImportAPI,
        contacts: crmContactsExcelImportAPI,
        product: crmProductExcelImportAPI
      }[this.crmType];
      this.loading = true;
      if (this.config.importParams) {
        params = _extends({}, params, this.config.importParams);
      }
      request(params).then(function (res) {
        if (result) {
          result(res);
        }
      }).catch(function () {
        if (result) {
          result(false);
        }
        _this2.loading = false;
      });
    },


    /**
     * 第二步查询数量
     */
    loopSecondQueryNum: function loopSecondQueryNum() {
      var _this3 = this;

      this.secondQueryNum();
      this.intervalTimer = setInterval(function () {
        if (_this3.processData.status == 'end') {
          clearInterval(_this3.intervalTimer);
          _this3.intervalTimer = null;
          _this3.thirdQueryResult();
        } else {
          _this3.secondQueryNum();
        }
      }, 2000);
    },
    secondQueryNum: function secondQueryNum() {
      var _this4 = this;

      crmQueryImportNumAPI({ messageId: this.messageId }).then(function (res) {
        if (res.data === null) {
          _this4.processData.status = 'end';
        } else {
          _this4.processData.status = '';
          _this4.processData.count = res.data;
        }
      }).catch(function () {
        // this.processData.status = 'err'
      });
    },


    /**
     * 第三部 查询结果
     */
    thirdQueryResult: function thirdQueryResult() {
      var _this5 = this;

      crmQueryImportInfoAPI({ messageId: this.messageId }).then(function (res) {
        _this5.loading = false;
        _this5.stepList[1].status = 'finish';
        _this5.stepsActive = 3;
        _this5.$emit('status', 'finish');
        if (res) {
          _this5.resultData = res.data;
          if (res.data.errSize > 0) {
            _this5.stepList[2].status = 'error';
          } else {
            _this5.stepList[2].status = 'finish';
          }
        }
      }).catch(function () {});
    },


    /**
     * 下载错误模板
     */
    downloadErrData: function downloadErrData(result) {
      var _this6 = this;

      this.loading = true;
      if (this.config.downloadErrFuc) {
        this.config.downloadErrFuc(result).then(function (res) {
          downloadExcelWithResData(res);
          _this6.loading = false;
        }).catch(function () {
          _this6.loading = false;
        });
      } else {
        crmDownImportErrorAPI({ messageId: this.messageId }).then(function (res) {
          downloadExcelWithResData(res);
          _this6.loading = false;
        }).catch(function () {
          _this6.loading = false;
        });
      }
    },


    // 下载模板操作
    download: function download() {
      var request = this.config.templateRequest || {
        customer: this.config.poolSelectShow ? crmCustomerPoolDownloadExcelAPI : crmCustomerDownloadExcelAPI,
        leads: crmLeadsDownloadExcelAPI,
        contacts: crmContactsDownloadExcelAPI,
        product: crmProductDownloadExcelAPI
      }[this.crmType];
      request(this.config.templateParams || {}).then(function (res) {
        downloadExcelWithResData(res);
      }).catch(function () {});
    },

    // 选择文件
    selectFile: function selectFile() {
      document.getElementById('importInputFile').click();
    },

    /** 图片选择出发 */
    uploadFile: function uploadFile(event) {
      var files = event.target.files;
      var file = files[0];
      if (verifyFileTypeWithFileName(file.name)) {
        this.file = file;
        // 阶段一状态
        this.getFirstStepStatus();
      }
      event.target.value = '';
    },

    // 用户选择
    userSelect: function userSelect(data) {
      if (data.value && data.value.length > 0) {
        this.user = data.value;
      } else {
        this.user = [];
      }

      // 阶段一状态
      this.getFirstStepStatus();
    },
    getFirstStepStatus: function getFirstStepStatus() {
      // 阶段一状态
      var hasFile = this.file && this.file.size;
      var hasUser = this.user && this.user.length > 0;

      if (this.config.ownerSelectShow) {
        this.stepList[0].status = hasFile && hasUser ? 'finish' : 'wait';
      } else {
        this.stepList[0].status = hasFile ? 'finish' : 'wait';
      }
    },


    /**
     * 公海数据
     */
    getPoolList: function getPoolList() {
      var _this7 = this;

      crmCustomerPoolNameListAPI().then(function (res) {
        _this7.poolList = res.data || [];
        _this7.poolId = _this7.poolList.length > 0 ? _this7.poolList[0].poolId : '';
      }).catch(function () {});
    },


    // 关闭操作
    closeView: function closeView() {
      // this.$emit('update:show', false)
      this.showCRMImport = false;
      if (this.stepsActive == 3) {
        this.$bus.emit('import-crm-done-bus', this.crmType);
        Lockr.rm('crmImportInfo');
      }
      // this.$emit('close', this.stepsActive == 3 ? 'finish' : '')
      this.crmImportClose(this.stepsActive == 3 ? 'finish' : '');
    },


    /**
     * 重置页面数据
     */
    resetData: function resetData() {
      this.repeatHandling = 1;
      this.file = { name: '' };
      this.user = [];

      this.stepsActive = 1;
      this.stepList = [{
        icon: 'wk wk-upload',
        title: '上传文件',
        status: 'wait'
      }, {
        icon: 'wk wk-data-import',
        title: '导入数据',
        status: 'wait'
      }, {
        icon: 'wk wk-success',
        title: '导入完成',
        status: 'wait'
      }];
      this.resultData = null;
      this.processData = {
        count: 0,
        status: ''
      };
      this.messageId = null;
    },


    /**
     * 获取验证字段
     */
    getField: function getField() {
      var _this8 = this;

      var params = {
        label: crmTypeModel[this.crmType],
        type: 1
      };

      filedGetFieldAPI(params).then(function (res) {
        _this8.fieldList = res.data;
      }).catch(function () {});
    }
  }
};